import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { 
    FaHome, 
    FaUser, 
    FaSchool, 
    FaChalkboardTeacher, 
    FaUserGraduate, 
    FaUserTie,
    FaClipboardList,
    FaBookReader,
    FaCalendarAlt,
    FaBell,
    FaSignOutAlt,
    FaBars,
    FaTimes,
    FaUserPlus,
    FaCog
} from 'react-icons/fa';
import { setIsLogoLeftMargin, setIsSidebarCollapsed } from './reduxToolkit/redux';
import './SideMenu.scss';
import MyRoom_aca from './page_myRoom/MyRoom_aca';
import MyRoom_stu from './page_myRoom/MyRoom_stu';
import { billingUiEnabled } from './billing/billingClient';




const SideMenu = () => {
    const [toggled, setToggled] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [isTablet, setIsTablet] = useState(window.innerWidth > 768 && window.innerWidth <= 1200);
    
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    
    const isLoggedIn = useSelector((state) => state.reduxStore.isLoggedIn);
    const userInfo = useSelector((state) => state.reduxStore.userInfo);
    const selectedUserInfo = useSelector((state) => state.reduxStore.selectedUserInfo);
    const collapsed = useSelector((state) => state.reduxStore.isSidebarCollapsed);
    const collapseMinWidth = isTablet ? '0rem !important' : '3rem !important';
    const collapseMaxWidth = '15rem !important';

    // SideMenu.jsx
    const COLLAPSED_W = '13rem';
    const EXPANDED_W  = '15rem';

    useEffect(() => {
    // 모바일: 오버레이 -> 본문/모달은 좌측 여백 0
    // 태블릿: 접힘=0px, 펼침=15rem
    // 데스크톱: 접힘/펼침에 따라 여백 다르게
    const offset = isMobile
        ? '0px'
        : (isTablet
            ? (collapsed ? '0px' : EXPANDED_W)
            : (collapsed ? COLLAPSED_W : EXPANDED_W));
    document.documentElement.style.setProperty('--sidebar-offset', offset);

    // alert(`isMobile: ${isMobile}, isTablet: ${isTablet}, collapsed: ${collapsed}, toggled: ${toggled}`);
    }, [isMobile, isTablet, collapsed, toggled]);

        

    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth <= 768;
            const tablet = window.innerWidth > 768 && window.innerWidth <= 1200;
            setIsMobile(mobile);
            setIsTablet(tablet);
            // console.log('Window width:', window.innerWidth, 'isMobile:', mobile, 'isTablet:', tablet);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);

    }, []);



    // When switching to desktop/tablet, ensure mobile side menu flag is false and sidebar closed
    useEffect(() => {
        if (!isMobile) {// 데스크톱/태블릿 모드로 전환될 때
            setToggled(false);
            dispatch(setIsLogoLeftMargin(false));
            if (isTablet) {
                dispatch(setIsSidebarCollapsed(true)); // 태블릿: 사이드바 기본 숨김
            } else {
                dispatch(setIsSidebarCollapsed(false)); // PC: 사이드바 기본 펼침
            }
        } else {
            dispatch(setIsLogoLeftMargin(true));// 모바일 모드로 전환될 때 무조건 여백 줌
        }
    }, [isMobile, isTablet, dispatch]);



     

   //=============================================
    return (
        <>
        <div className='SideMenu'>
            {/* 모바일 플로팅 토글 버튼 모바일에서 사이드메뉴 펼치는 버튼*/}
            {isMobile && !toggled && (
                <button 
                    className="mobile-floating-toggle"
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setToggled(true);
                        dispatch(setIsLogoLeftMargin(false));//모바일 플로트 버튼
                    }}
                >
                    <FaBars />
                </button>
            )}
            
            <div className={`sidebar-container ${toggled ? 'mobile-open' : ''}`}>

                <Sidebar
                    collapsed={collapsed}
                    toggled={toggled}
                    onBackdropClick={() => {
                        setToggled(false);
                    }}
                    breakPoint="md"
                    // backgroundColor="#2da18fff"
                    // width={collapsed ? '4rem !important' : '15rem !important'}
                    width={collapsed ? collapseMinWidth : collapseMaxWidth}
                >
                    {/* 헤더 영역 */}
                    <div className="sidebar-header" style={{ width: collapsed ? collapseMinWidth : collapseMaxWidth }}>
                        
                        <div className="logo-section">
                            {!collapsed && (
                                <div className="logo-text">
                                    {isLoggedIn && userInfo && (
                                        <p className="user-welcome">
                                            <FaUser className='user-icon' />
                                            {userInfo.name}님
                                        </p>
                                    )}
                                </div>
                            )}
                        </div>
                        
                        {/* 모바일 닫기 버튼 */}
                        {isMobile && (
                            <button 
                                className="close-btn"
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setToggled(false);
                                    dispatch(setIsLogoLeftMargin(true));//모바일 닫기 버튼
                                }}
                            >
                                <FaTimes />
                            </button>
                        )}
                        
                        {/* PC/태블릿 데스크톱 우측 토글 버튼 */}
                        {!isMobile && (
                            <button 
                                className="collapse-btn"
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    dispatch(setIsSidebarCollapsed(!collapsed));
                                    // alert(collapsed ? '사이드메뉴 펼침' : '사이드메뉴 접음');  
                                }}
                            >
                                {collapsed ? <FaBars /> : <FaTimes />}
                            </button>
                        )}
                    </div>

                    {/* 메뉴 영역 */}
                    {!collapsed && (
                        <Menu   
                            onClickCapture={(e) => {//부모에서 부터 이벤트 발생
                                // Close sidebar on any menu click in mobile
                                if (isMobile) {
                                    setToggled(false);
                                    dispatch(setIsLogoLeftMargin(true));//모바일 메뉴 클릭 시
                                    
                                }
                            }}
                        >
                            {userInfo && userInfo.kind == 1  && (
                                <MyRoom_stu />
                            )}
                            {userInfo && userInfo.kind == 2  && (
                                <MyRoom_aca />
                            )}
                            {billingUiEnabled && String(userInfo?.kind) === '2' && (
                                <MenuItem icon={<FaUser />} onClick={() => navigate('/ai-wallet')}>내 AI 지갑 · 충전</MenuItem>
                            )}

                        </Menu>
                    )}
                </Sidebar>
            </div>
            </div>
        </>
    );
};

export default SideMenu;
